// src/components/esg/CountryButton.jsx
import React from "react";
import { Button } from "@mui/material";

const CountryButton = ({ title, onClick, ...rest }) => {
  return (
    <Button
      onClick={onClick}
      fullWidth={false}
      disableRipple
      sx={{
        /* Layout */
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "nowrap",

        /* Dimensions — EXACT */
        width: "707px",
        height: "64px",
        padding: "12px 24px",
        marginBottom: "16px",

        /* Typography — EXACT */
        fontFamily: "DM Sans, sans-serif",
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "24px",
        letterSpacing: "-0.02em",
        textTransform: "none",
        textAlign: "left",

        /* Colors */
        backgroundColor: "#02462E",
        color: "#FCFCFC",
        border: "none",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        "&:hover": {
          backgroundColor: "#02462E",
          color: "#FCFCFC",
        },
        "&:active": {
          backgroundColor: "#02462E",
          color: "#FCFCFC",
        },
        "&.Mui-focusVisible": {
          backgroundColor: "#02462E",
          color: "#FCFCFC",
        },

        transition: "none",
        "@media (max-width:600px)": {
          width: "100%",
          height: "auto",
          fontSize: "18px",
          lineHeight: "22px",
          padding: "10px 16px",
          flexWrap: "wrap",
          whiteSpace: "normal",
        },

        ...rest.sx,
      }}
      {...rest}
    >
      {title}
    </Button>
  );
};

export default CountryButton;
